<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1A7dkGc/media/FC-9781035837168.jpg?1718732568204" alt="This image is the cover for the book Robin Rainbow"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Robin Rainbow
      </h1>
      <p class="bookDescription body article font2">
        <p>Robin Rainbow is a contemporary work of fiction written for young adults. The discovery of a casket that contains a map with a riddle sends Robin and his school friends on a quest that leads them to encounter the ever-present forces of Evil that lurk everywhere. Dramatic turning-points that include their capture, escape, recapture, their rescue via celestial beings and their return to ‘everyday reality, dictate the novel’s narrative arc. When at war with the powers of evil, concern at their disappearance from home and school soon becomes global. To find the missing children, huge rewards are offered that tempt bounty-hunters from across the world. Their disappearance is taken more seriously than any illegal invasion of another country or outbreak of Covid-19 and its variants or any alleged alien abduction! Conversational in style, the text both challenges and entertains. The element of surprise, a deep thirst for adventure, the search for knowledge and happiness sustain the reader’s interest throughout.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Donald McCrory
      </h2>
      
      <p class="authorDescription body article">Dr McCrory has written historical biographies of Miguel de Cervantes and A. von Humboldt, four novels, several academic texts and essays and has won national and international awards for his poetry. He was also a Fellow of the Royal Geographical Society. He took early retirement from his post as Head of Hispanic and Germanic Studies at the American International University in London to focus on 1) creative writing, 2) further study of Eastern Languages, especially Sanskrit, Hindi and Mandarin, as well as of Eastern philosophies and religions, in particular Advaita Vedanta and Buddhism. Donald enjoys studying languages, travel, opera and classical theatre and currently lives in Spain.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?963442a2